import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc.js';
import { SelectHourData } from '../data/SelectHourData';

//Current date
let dayArray = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
];
dayjs.extend(updateLocale);
dayjs.locale('fr');
dayjs.extend(utc);

const weekDay = dayArray[dayjs().day()];
const currentFormatDate = dayjs().format('DD MMMM YYYY');

export const currentDate = weekDay + ' ' + currentFormatDate;
export const currentIsoDate = dayjs().toISOString();

export function dayJS(isoDate = undefined) {
  return isoDate === undefined ? dayjs() : dayjs(isoDate);
}

export function formatDate(isoDate, format) {
  const dayJsDate = dayjs(isoDate);
  return dayJsDate.format(format);
}

// on cree un objet dayjs a partir de l'iso, on met a jour les heures et les minutes. Cette fonction retourne elle meme un iso
export function computeDateHour(isoDate, hour, minute) {
  let dayJsDate = dayjs(isoDate);

  dayJsDate = dayJsDate.hour(hour);
  dayJsDate = dayJsDate.minute(minute);

  return dayJsDate.format();
}

export function getMonth(isoDate) {
  return dayjs(isoDate).month();
}

export function getYear(isoDate) {
  return dayjs(isoDate).year();
}

export function getDayJsFromIso(isoDate) {
  return dayjs(isoDate);
}

export function firstDateAfterSecondDate(date1, date2) {
  return dayjs(date1).isAfter(dayjs(date2));
}

export function getPaymentDate(paymentPeriod, fromIsoDate, next = true) {
  let dayJsDate = dayjs(fromIsoDate);

  switch (paymentPeriod) {
    case 'immediat': {
      dayJsDate = next
        ? dayJsDate.add(1, 'month')
        : dayJsDate.subtract(1, 'month');
      break;
    }
    case 'annuel': {
      dayJsDate = next
        ? dayJsDate.add(1, 'year')
        : dayJsDate.subtract(1, 'year');
      break;
    }
    case 'mensuel': {
      dayJsDate = next
        ? dayJsDate.add(1, 'month')
        : dayJsDate.subtract(1, 'month');
      break;
    }
    case 'trimestriel': {
      dayJsDate = next
        ? dayJsDate.add(3, 'month')
        : dayJsDate.subtract(3, 'month');
      break;
    }
    case 'semestriel': {
      dayJsDate = next
        ? dayJsDate.add(6, 'month')
        : dayJsDate.subtract(6, 'month');
      break;
    }
    default: {
      return null;
    }
  }

  return dayJsDate.toISOString();
}

export function getMonthsList() {
  let monthList = [];

  for (let i = 0; i < 12; i++) {
    const monthDate = dayjs().month(i);

    monthList.push({
      value: formatDate(monthDate.toISOString(), 'MMMM'),
      label: formatDate(monthDate.toISOString(), 'MMMM'),
      number: i,
    });
  }

  return monthList;
}

export function getWeekDays(currentIsoDate = undefined) {
  let dayList = [];
  const currentDate =
    currentIsoDate !== undefined ? dayjs(currentIsoDate) : dayjs();
  const currentDay = currentDate.day();
  let modifier = 0;

  for (let i = 1; i < 7; i++) {
    let calculateDate =
      currentIsoDate !== undefined ? dayjs(currentIsoDate) : dayjs();

    calculateDate = processDayDate(calculateDate, currentDay, i, modifier);
    // check if it's sunday, then update modifier

    if (calculateDate.day() === 0) {
      modifier++;
      calculateDate = processDayDate(currentDay, i, modifier);
    }

    dayList.push({
      day: formatDate(calculateDate, 'ddd'),
      dayDate: formatDate(calculateDate, 'DD'),
      isoDate: calculateDate.utc().toISOString(),
    });
  }

  return dayList;
}

function processDayDate(calculateDate, currentDay, i, modifier) {
  if (currentDay >= i)
    return calculateDate.subtract(currentDay - i - modifier, 'days');
  else return calculateDate.add(i - currentDay + modifier, 'days');
}

export function avoidSaturdayDate(isoDate) {
  let date = dayjs(isoDate);

  if (date.day() === 0) date = date.add(1, 'day');

  return date.toISOString();
}

export function getDayHourList(isoDate) {
  let date = dayjs(isoDate);
  date = date.hour(9).minute(0).second(0).millisecond(0);

  let hoursList = [];

  for (let i = 0; i < SelectHourData.length; i++) {
    hoursList.push(formatDate(date, 'HH:mm'));

    date = date.add(30, 'minutes');
  }

  return hoursList;
}

export const dayToDate = {
  lundi: 0,
  mardi: 1,
  mercredi: 2,
  jeudi: 3,
  vendredi: 4,
  samedi: 5,
  dimanche: 6,
};
